import { IHasClassName } from '@/interfaces';
import { Button } from '@/components/ui';
import { CircleX } from 'lucide-react';
import { TNullable } from '@/types';
import { ReactNode } from 'react';
import { cn } from '@/lib/utils';

type TProps = IHasClassName & {
  value?: TNullable<string>;
  onClick?: () => void;
  onReset?: () => void;
  removable?: boolean;
  disabled?: boolean;
  text: ReactNode;
  title?: string;
};

const ButtonFilterText = ({ text, value, disabled, title, className, onReset, onClick, removable = true }: TProps) => {

  const handleOnClickBtnReset = () =>
    onReset?.();

  const hasValue = !!value;

  return (
    <div className={cn(
      'flex items-center my-auto',
      className
    )}>
      <Button
        className={cn(
          'flex items-center space-x-1 border border-dashed text-xs',
          removable &&
          onReset &&
          'border-r-0 rounded-r-none'
        )}
        variant={hasValue ? 'secondary' : 'ghost'}
        disabled={disabled}
        onClick={onClick}
        title={title}
        size={'sm'}>
        <div className='flex items-center'>
          {text}
          {
            hasValue &&
            <span>:</span>
          }
        </div>
        {
          hasValue &&
          <span className='text-purple-600 font-semibold'>
            {value}
          </span>
        }
      </Button>
      {
        removable &&
        onReset &&
        <Button
          className='space-x-1 border border-dashed border-l-0 rounded-l-none text-xs'
          variant={'secondary'}
          title='Supprimer le filtre'
          onClick={handleOnClickBtnReset}
          disabled={disabled}
          size={'sm'}>
          <CircleX size={16} />
        </Button>
      }
    </div>
  );

};

export default ButtonFilterText;
